import React from "react";
import "./LoadingPage.css";

export default function LoadingPage() {
  return (
    <div className='loading-div'>
      <h1 className="loading-icon">getInvolved</h1>
      <span className="loading-span">loading...</span>
    </div>
  );
}
